/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { orphanedInstanceTalliesSchema } from './orphanedInstanceTalliesSchema';

export const orphanedInstanceWithTalliesSchema = z.object({
  instanceId: z.string(),
  instanceName: z.string().nullish(),
  instanceUrl: z.string().nullish(),
  markedOrphanedAt: z.iso.datetime(),
  get tallies() {
    return orphanedInstanceTalliesSchema;
  },
});
